import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ManageOpenShiftsService } from 'app/modules/manage-shifts/services/manage-open-shifts.service';
import { AppSettings } from 'app/modules/shared/app.settings';
import { CommonBindingDataService } from 'app/modules/shared/services/common-binding-data.service';
import { UiService } from 'app/modules/shared/services/ui.service';
import * as moment from 'moment-timezone';
@Component({
  selector: 'app-manage-shifts-team-members-week-list',
  templateUrl: './manage-shifts-team-members-week-list.component.html',
  styleUrls: ['./manage-shifts-team-members-week-list.component.scss']
})
export class ManageShiftsTeamMembersWeekListComponent implements OnInit {
  @Input() searchTeam: any;
  @Input() fromDate: any;
  @Input() selectedAvailability: any;
  @Input() selectedRole: any;
  @Input() userRoleIds: any;
  @Input() offset: any;
  @Input() isPastDate: any;
  @Input() providerId: any;
  @Input() serviceRegionIds: any;
  @Output() totalCount: EventEmitter<any> = new EventEmitter<any>();
  @Output() offsetEmmiter: EventEmitter<any> = new EventEmitter<any>();
  toDate: any = new Date();
  dayOffset = AppSettings.ONE_DAY_IN_MILISECOND;
  teamMemberDetails: any[] = [];
  editSlotDetails: any;
  addTimeOffDetails: any;
  limit = 10;
  currentOffset = 10;
  selectedTeam: any;
  selectedDate: any;
  driverId: any;
  shiftDetails: any;
  showAddTimeOffPopup = false;
  showEditPopup = false;
  sortType = 'asc';
  showRole: Boolean = false;
  constructor(private manageOpenShiftsService: ManageOpenShiftsService,
    private uiService: UiService, private router: Router, private commonService: CommonBindingDataService) { }
  globalConfigPTO: Boolean = false;
  organizationLevelShift: Boolean = false;
  providerArr = [];
  teamDOOArr = [];


  ngOnInit(): void {
   this.showRoleName();
   this.globalConfigPTO = this.commonService.getGlobalConfigByKey(AppSettings.GLOBAL_CONFIGRATION.PTO)?.value;
   this.organizationLevelShift = this.commonService.getGlobalConfigByKey(AppSettings.GLOBAL_CONFIGRATION.ORGANIZATION_LVL)?.value;
   this.commonService.getDutyOnOffDispatchLevelArr(AppSettings.GLOBAL_CONFIGRATION.PROVIDER_LVL)?.forEach(ele => {
      this.providerArr.push(ele.providerId);
    });
   this.commonService.getDutyOnOffDispatchLevelArr(AppSettings.GLOBAL_CONFIGRATION.TEAM_LVL)?.forEach(ele => {
      this.teamDOOArr.push(ele.teamId);
    });
  }

  showRoleName() {
    setTimeout(() => {
    if (this.selectedRole === '20') {
        this.showRole = true;
      } else {
        this.showRole = false;
      }
    }, 1000);
  }

  ngOnChanges() {
    this.toDate.setTime(moment(this.fromDate).add(6, 'days').valueOf());
    this.getTeamMemberList();
    this.showRoleName();
  }

  getTeamMemberList() {
    // this.isLoaded = false;
    const formattedFromDate = moment(this.fromDate).format('YYYY/MM/DD');
    const formattedToDate = moment(this.toDate).format('YYYY/MM/DD');
    const formattedStatusId = this.selectedAvailability.length ? this.selectedAvailability : '';
    this.manageOpenShiftsService.getTeamMemberList(formattedFromDate, formattedToDate, this.limit,
      this.offset, this.searchTeam, formattedStatusId, this.selectedRole, this.userRoleIds,  this.sortType, 'week',
      this.providerId, this.serviceRegionIds)
      .subscribe((teamMemberDetails) => {
        // this.isLoaded = true;
        this.totalCount.emit(teamMemberDetails.count);
        if (this.offset > this.currentOffset) {
          this.currentOffset = this.offset;
          const data = teamMemberDetails.data;
          this.teamMemberDetails = [...this.teamMemberDetails, ...data];
        } else {
          this.teamMemberDetails = teamMemberDetails.data;
          this.currentOffset = this.offset;
        }
      },
        (error) => {
          this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
          // this.isLoaded = true;
        });
  }

  openShift(teamDetails) {
    // this.hasShowManageShiftPopUp = true;
    this.selectedTeam = teamDetails.teamName;
    this.selectedDate = teamDetails.date;
    this.driverId = teamDetails.userId;
    this.shiftDetails = teamDetails;
  }

  openAddTimeOffPopup(timeOffDetails) {
    this.showAddTimeOffPopup = true;
    this.addTimeOffDetails = timeOffDetails;
  }

  openEditSlotPopup(editSlotDetails) {
    this.showEditPopup = true;
    this.editSlotDetails = editSlotDetails;
  }

  onClickOfPopupButton(isEditSlot: boolean) {
    this.showEditPopup = false;
    if (isEditSlot) {
      this.offset = 0;
      this.offsetEmmiter.emit(0);
      this.getTeamMemberList();
    }
  }

  closeAddTimeOffPopup(isAddedTimeOff: boolean) {
    this.showAddTimeOffPopup = false;
    if (isAddedTimeOff) {
      this.offset = 0;
      this.offsetEmmiter.emit(0);
      this.getTeamMemberList();
    }
  }

  cancelLeave(isLeaveAdded: boolean) {
    this.offset = 0;
    this.offsetEmmiter.emit(0);
    this.getTeamMemberList();
  }

  sortTeamMembers() {
    this.sortType = this.sortType === 'asc' ? 'desc' : 'asc';
    this.offset = 0;
    this.offsetEmmiter.emit(0);
    this.getTeamMemberList();
  }

  addDeleteShift(userId: any, providerId: any, firstName: any, lastName: any, userType: any) {
    const addedMemberArr = this.teamMemberDetails.filter(ele => ele.userId === userId);
    if (addedMemberArr[0]?.memberSchedules[0]?.userTeams?.length) {
      const teamId = addedMemberArr[0]?.memberSchedules[0]?.userTeams[0]?.teamId;
      this.router.navigate(['/manage-shift/add-delete-shift-planning'], {
        queryParams: { userId: userId, providerId: providerId, f : firstName, l: lastName, userType: userType, teamId }
      });
    } else {
      this.router.navigate(['/manage-shift/add-delete-shift-planning'], {
        queryParams: { userId: userId, providerId: providerId, f : firstName, l: lastName, userType: userType }
      });
    }
  }

}
